import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from 'antd';
import { CollapseBlock } from '../../../../../common';

const PhdSettingsSection = ({ title, description, children }) => (
  <CollapseBlock
    collapsible
    title={
      <span
        style={{
          fontSize: 20,
          lineHeight: 1.25,
          fontWeight: 600,
          color: 'inherit',
        }}
      >
        {title}
      </span>
    }
  >
    {description ? (
      <Typography.Paragraph type="secondary" style={{ marginBottom: 16 }}>
        {description}
      </Typography.Paragraph>
    ) : null}
    {children}
  </CollapseBlock>
);

PhdSettingsSection.propTypes = {
  children: PropTypes.node,
  description: PropTypes.node,
  title: PropTypes.node.isRequired,
};

export default PhdSettingsSection;
